module.exports = __webpack_public_path__ + "static/media/Reporting11.9ce76022.png";